import { apiRequest } from "../lib/apiClient";
import type { StockTransferCreate, StockTransferOut } from "./types";

export async function listStockTransfers(accessToken: string): Promise<StockTransferOut[]> {
  return apiRequest<StockTransferOut[]>("/stock-transfers", { accessToken });
}

export async function createStockTransfer(accessToken: string, body: StockTransferCreate): Promise<StockTransferOut> {
  return apiRequest<StockTransferOut>("/stock-transfers", { method: "POST", accessToken, body });
}
